import cn from 'classnames'
import InputStyle from './Input_styles'

const Input = ({ className, ...others }) => {
  return <InputStyle {...others} className={cn(className)} />
}

export default Input
